/* eslint-disable */
import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import styles from './index.css';

import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';

import Chip from 'Chip';

class ImgBox extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        curArea: PropTypes.string,
        rankingNav: PropTypes.array,
    };

    render() {
        const { curArea, content, rankingNav } = this.props;
        const loadImgUrl =
            'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="349" height="196"><text x="120" y="108" fill="%23dcdcdc" style="font-size: 28px;">鳳凰新聞</text></svg>';

        return (
            <div className={styles.imgBox}>
                {rankingNav.map(
                    p =>
                        p.title === curArea ? (
                            content.filter(i => i.title === p.title)[0] ? (
                                content
                                    .filter(i => i.title === p.title)[0]
                                    .imgUrl.split(',')
                                    .map((i, j) => (
                                        <div
                                            key={j}
                                            className={styles.innerBox}
                                            style={{
                                                marginBottom:
                                                    j ===
                                                    content.filter(i => i.title === p.title)[0].imgUrl.split(',')
                                                        .length -
                                                        1
                                                        ? 0
                                                        : 50,
                                            }}>
                                            <img src={i} alt="" />
                                        </div>
                                    ))
                            ) : (
                                <div className={styles.innerBox}>
                                    <img src={loadImgUrl} alt="" />
                                </div>
                            )
                        ) : null,
                )}
            </div>
        );
    }
}

const ImgBoxChip = props => {
    return (
        <Chip id="170131" type="struct" title="美食盛典-美食榜单" groupName="正文-美食榜单" content={props.rankingList}>
            <ImgBox curArea={props.curArea} rankingNav={props.rankingNav} />
        </Chip>
    );
};

ImgBoxChip.propTypes = {
    rankingList: PropTypes.array,
    curArea: PropTypes.string,
    rankingNav: PropTypes.array,
};

export default errorBoundary(ImgBoxChip);
